<template>
  <div class="filter" :class="[posClass, { fixed: tabFixed }]">
    <ul>
      <li @click="selectSelf" :class="{ checked: isSelfSelected }">
        <a href="javascript:;"
          ><span class="text">{{ zeroText }}</span></a
        >
      </li>
      <li
        @click="selectService"
        :class="{ selected: firstText !== textList[0], show: selected.first }"
      >
        <a href="javascript:;"
          ><span class="text">{{ firstText }}</span
          ><span class="icon" :class="{ 'icon-rotate': selected.first }"
            ><i class="iconfont icon-jiantou"></i></span
        ></a>
      </li>
      <li
        @click="selectArea"
        :class="{ selected: secondText !== textList[1], show: selected.second }"
      >
        <a href="javascript:;"
          ><span class="text">{{ secondText }}</span
          ><span :class="{ 'icon-rotate': selected.second }"
            ><i class="iconfont icon-jiantou"></i></span
        ></a>
      </li>
      <li
        @click="selectBusiness"
        :class="{ selected: thirdText !== textList[2], show: selected.third }"
      >
        <a href="javascript:;"
          ><span class="text">{{ thirdText }}</span
          ><span :class="{ 'icon-rotate': selected.third }"
            ><i class="iconfont icon-jiantou"></i></span
        ></a>
      </li>
    </ul>
    <actionSheet
      :viewName="viewName"
      :params="params"
      :top="scrollTop"
      :heightClass="heightClass"
    ></actionSheet>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import actionSheet from '../actionSheet/upAction'

export default {
  props: {
    citycode: {
      type: [String],
      default: '320100'
    },
    tabFixed: {
      type: Boolean,
      default: false
    },
    posClass: {
      type: String,
      default: 'fixedTop' // 顶部fixed传 fixedTop,否则传default
    },
    heightClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      params: {},
      isSelfSelected: false,
      selected: { first: false, second: false, third: false },
      textList: ['项目', '区域', '商家'],
      zeroText: '孩子王自营',
      firstText: '项目',
      secondText: '区域',
      thirdText: '商家',
      selectAllText: '全部',
      scrollTop: ''
    }
  },
  computed: {
    ...mapState([
      'viewName',
      'serverArea',
      'serviceTypeList',
      'filterService',
      'areaList',
      'isActionSheetShow',
      'businessList',
      'filterBusiness'
    ])
  },
  created() {
    if (this.filterService.length > 0) {
      this.firstText = this.filterService[0].categoryName
    }
  },
  watch: {
    isActionSheetShow(val) {
      if (!val) {
        this.selected = { first: false, second: false, third: false }
        if (this.$route.name !== 'activity-share') {
          document.querySelector('.fixed-content').classList.remove('fixedTop')
        }
      } else {
        const el = document.querySelector('.filter')
        console.log(el.classList.contains('fixed'))
        /*eslint-disable*/
                if (el.classList.contains('fixed')) {
                    this.scrollTop = `45px`
                } else {
                    const top = el.offsetTop - document.documentElement.scrollTop + el.offsetHeight
                    this.scrollTop = `${top}px`
                }
                if (this.$route.name === 'activity-share') {
                    this.$emit('showSheet')
                } else {
                    document.querySelector('.fixed-content').classList.add('fixedTop')
                }
            }
        },
        serverArea(val, oldVal) {
            this.selected.second = false
            if (val && val.length > 0) {
                this.secondText = val[0].NAME
            } else {
                this.secondText = this.textList[1]
            }
            this.$emit('doSearch')
        },
        filterService(val) {
            this.selected.first = false
            if (val && val.length > 0) {
                this.firstText = val[0].categoryName
            } else {
                this.firstText = this.textList[0]
            }
            this.$emit('doSearch')
        },
        filterBusiness(val) {
            this.selected.third = false
            if (val && val.length > 0) {
                this.thirdText = val[0].businessName
            } else {
                this.thirdText = this.textList[2]
            }
            this.$emit('doSearch')
        }
    },
    methods: {
        ...mapMutations(['hideActionSheet', 'showActionSheet', 'changeView', 'setActionHeader', 'setFilterSelfSelf']),
        selectSelf() {
            this.hideActionSheet(false)
            this.selected = { first: false, second: false, third: false }
            this.isSelfSelected = !this.isSelfSelected
            this.setFilterSelfSelf(this.isSelfSelected)
            this.$emit('doSearch')
        },
        selectArea() {
            if (this.selected.second) {
                this.selected.second = false
                this.hideActionSheet(false)
                return
            }
            this.selected = { first: false, second: false, third: false }
            this.selected.second = true
            this.params = { cityId: this.citycode, needRestBt: false, needSelectAll: true, supportMuti: false }
            this.changeView('enteringAreaSelect')
            this.setActionHeader({
                title: '',
                show: false
            })
            this.showActionSheet();
        },
        selectService() {
            if (this.selected.first) {
                this.selected.first = false
                this.hideActionSheet(false)
                return
            }

            this.hideActionSheet(false)
            this.selected = { first: false, second: false, third: false }
            this.selected.first = true
            this.params = { needRestBt: false, supportMuti: false }
            this.changeView('serviceSheet')
            this.setActionHeader({
                title: '',
                show: false
            })
            this.showActionSheet();
        },
        selectBusiness() {
            if (this.selected.third) {
                this.hideActionSheet(false)
                this.selected.third = false
            } else {
                this.hideActionSheet(false)
                this.selected = { first: false, second: false, third: false }
                this.selected.third = true
                this.params = { cityId: this.citycode, needRestBt: true }
                this.changeView('businessSheet')
                this.setActionHeader({
                    title: '',
                    show: false
                })
                this.showActionSheet()
            }
        },
        selectTime() {
            if (this.selected.thrid) {
                this.hideActionSheet(false)
                this.selected.thrid = false
            } else {
                this.hideActionSheet(false)
                this.selected = { first: false, second: false, thrid: false }
                this.selected.thrid = true
                // this.params = { cityId: this.citycode, needRestBt: true }
                this.changeView('dateSheet')
                this.setActionHeader({
                    title: '',
                    show: false
                })
                this.showActionSheet();
            }
        }
    },
    components: {
        actionSheet
    }
}
</script>
<style lang="scss">
@import '../../assets/css/mixin';

.filter{
    .ui-address-choose{
        bottom: none !important;
        width:100%;
    }
    .ui-address-choose{
        bottom:0 !important;
        .ui-address-choose-select {
           margin-bottom: 0 !important;
           .ui-address-choose-select-item{
               margin-left:rem(30px);
               width:rem(330px);
               display: inline-block;

               &::after{
                   content:none !important;
               }
           }
       }
    }
    .ui-choose{
        bottom:0 !important;
        .ui-choose-select{
            margin-bottom: 0 !important;
        }
    }

    .ui-button{
        font-size: rem(36px);
    }
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.filter{
    width:100%;
    height:rem(90px);
    @include border(bottom) ;
    background-color: #fAfAfA;
    z-index:999;
    &.default{
        position: relative;
    }
    &.fixedTop{
        position: fixed;
        top:0;
        left:0
    }
    &.fixed{
        position: fixed;
        top:0;
        left:0
    }

    ul{
        position: relative;
        padding:rem(17px) 0;
        height:rem(90px);
        box-sizing: border-box;
        text-align: center;
        z-index:999;
        display: flex;
        align-items: center;

        li{
            position: relative;
            width: 25%;
            z-index: 999;
            box-sizing: border-box;
            font-size: rem(28px);

            a{
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                color: #121212;
            }

            span.text{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
                position: relative;
                display: inline-block;
                max-width: 100%;
                line-height: rem(90px);
                padding-right: rem(20px);
            }

            .iconfont{
                // padding-left:rem(20px);
                // padding-right:rem(8px);
                color:#121212;
                font-size: rem(20px);
            }
        }

        // li:nth-child(2){
        //     @include border(left);
        // }
        .show{
            a{
                color:#121212 !important;
                height: rem(74px);
                // background-color: #fff;
            }
            a::after{
                content: "";
                position: absolute;
                left: 1px;
                right: 1px;
                bottom: 0;
                height: 4px;
                z-index: 2;
            }

            .iconfont{
                color:#121212 !important;
            }
            a::before{
                border-color:#ebebeb !important;
                border-bottom-color: #fff !important;
            }
            .iconfont{
                // display: inline-block;
                // transform: rotate(180deg);
                // transition: transform .2s;
                // padding-right:rem(8px);
                // padding-left:0;
            }
        }
        .checked{
            background: #F3E4FF;
            a{
                font-size: rem(28px);
                color: #AE47FF;
                font-weight: 500;
            }

        }
        .selected{
            a{
                color: #ff397e;
                // background-color: #fff;
            }

            a::before{
                border-color:#ff397e;
            }
            .iconfont{
                color:#ff397e;
            }
        }
    }
    // .icon{
    //     padding-left: rem(20px);
    // }
    .icon-rotate{
        transform: rotate(180deg);
    }
}
</style>
